import { getDateFormat } from './time';

export function bookingSubmitRedirect(type, date, time, postcode, address, appointmentType) {
  const formattedDate = `date=${getDateFormat(date)}`;
  const formattedTime = `time=${time}`;
  const formattedType = `type=${type}`;
  const formattedAppointmentType = appointmentType ? `&appointmentType=${appointmentType}` : '';
  const formattedPostcode = postcode ? `&postcode=${postcode}` : '';
  const formatedAddress = address && address.fullAddress ? `&address=${address.fullAddress}` : '';
  const formatedLongitude = address && address.longitude ? `&longitude=${address.longitude}` : '';
  const formatedLatitude = address && address.latitude ? `&latitude=${address.latitude}` : '';
  const formatedFlatField1 = address && address.flatField1 ? `&flatField1=${address.flatField1}` : '';
  const formatedBuildingField1 = address && address.buildingField1 ? `&buildingField1=${address.buildingField1}` : '';
  const formatedStreetField1 = address && address.streetField1 ? `streetField1=${address.streetField1}` : '';
  const formatedCustom = address && address.custom ? `&custom=${address.custom}` : '';
  const result = `/booking?${formattedType}&${formattedDate}&${formattedTime}${formattedPostcode}${formatedAddress}${formatedLongitude}${formatedLatitude}${formatedFlatField1}${formatedBuildingField1}&${formatedStreetField1}${formatedCustom}${formattedAppointmentType}`;
  redirectToLocal(result);
}

export function prescriptionSubmitRedirect(date, id) {
  const result = `/prescription?dob=${getDateFormat(date)}&id=${id}`;
  redirectToLocal(result);
}

export function quotationPostcodeSearchRedirect(postcode) {
  const result = `/pharmacy-finder?postcode=${postcode}`;
  redirectToLocal(result);
}

export function quoteSubmitRedirect(data) {
  const formattedEmployees = `employees=${+data.employees || 0}`;
  const formattedCovidEmployees = `covidEmployees=${+data.covidEmployees || 0}`;
  const formattedClinics = `clinics=${+data.clinics || 0}`;
  const formattedVouchers = `vouchers=${+data.vouchers || 0}`;
  const result = `/quotation?${[formattedEmployees, formattedClinics, formattedVouchers, formattedCovidEmployees].join('&')}`;
  redirectToLocal(result);
}

export function vaccineBookingRedirect(quotationRequestId, clinicsCount) {
  const params = encodeURI(`/vaccine-booking?id=${quotationRequestId}&locationNumber=${+clinicsCount || 0}`);

  openInNewTab(params)
}

export function redirectToLocal(params) {
  window.location.href = window.location.origin + params;
}

export function redirectHome() {
  window.location = window.location.origin + '/home';
}

export function openInNewTab(params) {
  window.open(window.location.origin + params, '_blank');
}

export function redirectCorporateHome() {
  redirectToLocal('/flu-vaccination-vouchers');
}

export function parseParamsIntoObjects(params) {
  if (params.length > 0) {
    const paramsArray = getArrayFromParams(params);

    return paramsArray.reduce((acc, param) => {
      const [key, value] = param.split('=');
      acc = {
        ...acc,
        [key]: value,
      };
      return acc;
    }, {});
  }
}

function getArrayFromParams(params) {
  if (params.startsWith('?')) {
    return params.slice(1).split('&');
  }
  return params.split('&');
}
